import {
  useProductTranslations,
  useSpecsTranslation
} from "../../hooks/TranslationHooks";
import { productStockStatus } from "../../utils/ProductUtils";
import { Product } from "../../types/Product";
import { CartItem } from "../../types/CartItem";
import { StockIcon } from "../StockStatus";

const ProductStock = ({
  product,
  cartItem,
  b2b = false,
  short = false,
  salesUnit = "",
  className
}: {
  product: Product;
  cartItem?: CartItem;
  b2b?: boolean;
  short?: boolean;
  salesUnit?: string;
  className?: string;
}) => {
  const tp = useProductTranslations();
  const ts = useSpecsTranslation();
  const stockStatus = productStockStatus(product, cartItem, tp, b2b);

  return product.saleable || product.sampleSaleable ? (
    <div
      className={className}
      style={{
        display: "flex",
        flexDirection: short ? "column" : "row",
        alignItems: "center",
        rowGap: "0.4em"
      }}
    >
      <p style={{ fontSize: "1.25em", marginRight: "0.7em" }}>
        <StockIcon stockStatus={stockStatus} />
      </p>
      <p>
        {short
          ? stockStatus.amountShort
            ? stockStatus.amountShort +
              " " +
              (salesUnit ? tp("sales_unit." + salesUnit) : ts("unit.sqm"))
            : ""
          : (stockStatus.amount ? stockStatus.amount + " " : "") +
            stockStatus.message}
      </p>
    </div>
  ) : null;
};

export default ProductStock;
